import { render, staticRenderFns } from "./MotivoVisitaList.vue?vue&type=template&id=16b6c626&scoped=true"
import script from "./MotivoVisitaList.vue?vue&type=script&lang=js"
export * from "./MotivoVisitaList.vue?vue&type=script&lang=js"
import style0 from "./MotivoVisitaList.vue?vue&type=style&index=0&id=16b6c626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b6c626",
  null
  
)

export default component.exports